export const images = {
  playerAvatar: require("../../../assets/images/PlayerIcon.png"),
  photoUpload: require("../../../assets/images/upload-photo-button.png"),
  groupAvatar: require("../../../assets/images/GroupIcon.png"),
  assist: require("../../../assets/images/assist_image.png"),
  bgNextMatchWidget: require("../../../assets/images/bg-next-match.jpg"),
  footballFieldBg: require("../../../assets/images/football-field-bg.png"),
  recentMatchesBg: require("../../../assets/images/recent-matches-bg.jpg"),
  fakePlayer1: require("../../../assets/images/fake-player1.png"),
  fakePlayer2: require("../../../assets/images/fake-player2.png"),
  whiteTeamLogo:require("../../../assets/images/white-team.png"),
  blackTeamLogo:require("../../../assets/images/black-team.png"),
};
